// extracted by mini-css-extract-plugin
module.exports = {"Input":"Checkbox_Input__2VdpC","Label":"Checkbox_Label__k-uL4","InputElement":"Checkbox_InputElement__2WGLA","Invalid":"Checkbox_Invalid__30ZR2"};